import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
    OrderGuideServiceProxy,
    ArticleServiceProxy,
    ArticleDto,
    PagedResultDtoOfArticleDto,
    FieldTypes
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import moment from 'moment';

import { SearchAndSelectComponent } from
    '@app/shared/common/shop-system/common/search-and-select/search-and-select.component';
import { ColumnDefinition, AxillaPallet, AxillaPalletDimension } from '@app/shared/common/shop-system/models/models';
import { IColumnDefinition } from '@app/shared/common/shop-system/models/models';

@Component({
    selector: 'app-pallet',
    templateUrl: './pallet-details.component.html',
    styleUrls: ['./pallet-details.component.less']
})
export class PalletDetailsComponent extends AppComponentBase implements OnInit {

    @Input() pallet: AxillaPallet;

    get dimension(): AxillaPalletDimension {
        return this.pallet.dimension;
    }

    get isShowDimention(): boolean {
        return this.pallet.showDimension;
    }

    constructor(
        injector: Injector,
        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _articleServiceProxy: ArticleServiceProxy,
        private _activatedRoute: ActivatedRoute
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    getOverlayHeight(): string {

        if (this.pallet) {
            let height = this.pallet.usedSpace;
            return `used-${Math.round(height / 10) * 10}`;
        }


        return 'used-0';
    }


    getPalletImage() {
        let name = 'packages-25.png';
        if (this.pallet.usedSpace > 25 && this.pallet.usedSpace <= 50) {
            name = 'packages-50.png';
        } else if (this.pallet.usedSpace > 51 && this.pallet.usedSpace <= 85) {
            name = 'packages-75.png';
        } else if (this.pallet.usedSpace > 86 && this.pallet.usedSpace <= 100) {
            name = 'full-packages.png';
        }


        return `${this.appRootUrl()}assets/common/images/pallets/${name}`;
    }

}
